import { useEffect, useState } from "react";
import { X, ArrowRight } from "@phosphor-icons/react";
import api from "@/lib/api";

const STORAGE_KEY = "ciq_onboarding_done";

export default function OnboardingTour() {
  const [steps, setSteps] = useState([]);
  const [idx, setIdx] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) === "1") return;
    api.get("/onboarding").then((r) => {
      setSteps(r.data.steps);
      setOpen(true);
    });
  }, []);

  if (!open || steps.length === 0) return null;
  const step = steps[idx];
  const next = () => {
    if (idx + 1 >= steps.length) finish();
    else setIdx(idx + 1);
  };
  const finish = () => {
    setOpen(false);
    localStorage.setItem(STORAGE_KEY, "1");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="relative w-full max-w-lg theme-surface border theme-border p-8 mx-4">
        <button
          data-testid="onboarding-close"
          onClick={finish}
          className="absolute top-4 right-4 theme-ink-dim hover:theme-ink"
        >
          <X size={18} />
        </button>
        <div className="overline">Step {idx + 1} of {steps.length}</div>
        <h2 className="font-serif-display text-3xl theme-ink mt-2">{step.title}</h2>
        <p className="theme-ink-muted text-sm mt-3 leading-relaxed">{step.body}</p>

        <div className="flex items-center gap-1 mt-6">
          {steps.map((_, i) => (
            <span
              key={i}
              className={`h-[2px] flex-1 ${i <= idx ? "bg-gold" : "bg-black/10 dark:bg-white/10"}`}
            />
          ))}
        </div>

        <div className="mt-6 flex items-center justify-between">
          <button
            data-testid="onboarding-skip"
            onClick={finish}
            className="text-xs theme-ink-muted hover:theme-ink"
          >
            Skip the tour
          </button>
          <button
            data-testid="onboarding-next"
            onClick={next}
            className="bg-gold text-black px-5 py-2 text-sm font-medium rounded-sm hover:bg-[#e0bc40] flex items-center gap-2"
          >
            {idx + 1 >= steps.length ? "Get started" : "Next"} <ArrowRight size={14} weight="bold" />
          </button>
        </div>
      </div>
    </div>
  );
}
